import React from "react";
function JoinUs() {
  return( <div>
    <h1>joinus</h1>
  </div>
  );
}
export default JoinUs;